import React from 'react'

const AccessDistributionSkeleton = () => {
  return (
    <div className='border rounded p-5 w-full h-auto bg-[var(--color-common-bg-base)] border-[var(--color-common-border)]'>
      <div className='flex justify-between items-center mb-4'>
        <div className='h-6 bg-gray-200 rounded w-1/3 animate-pulse'></div>
        <div className='h-4 bg-gray-200 rounded w-1/4 animate-pulse'></div>
      </div>
      <div className='flex items-center justify-around'>
        <div className='space-y-4 w-1/2'>
          {[...Array(4)].map((_, i) => (
            <div key={i} className='flex items-center space-x-4'>
              <div className='h-8 w-8 bg-gray-200 rounded-full animate-pulse'></div>
              <div className='flex-1 space-y-2'>
                <div className='h-4 bg-gray-200 rounded w-3/4 animate-pulse'></div>
                <div className='h-4 bg-gray-200 rounded w-1/2 animate-pulse'></div>
              </div>
            </div>
          ))}
        </div>
        <div className='w-48 h-48 bg-gray-200 rounded-full animate-pulse'></div>
      </div>
    </div>
  )
}

export default AccessDistributionSkeleton
